import { HRHelpdeskAgentEditor } from "./hr-helpdesk";
import { Agent } from "../api";

export interface AgentTypeEditorProps {
  agent: Agent;
  onChange: (config: any) => void;
}

export interface AgentTypeEditor {
  type: string;
  title?: string;
  Editor: (props: AgentTypeEditorProps) => JSX.Element;
}

const AgentTypeEditors: AgentTypeEditor[] = [
  { type: "hr-helpdesk", title: "Helpdesk", Editor: HRHelpdeskAgentEditor }
];

export const getAgentTypeEditor = (type: string) => {
  const editor = AgentTypeEditors.find(ae => ae.type === type);
  return editor ?? null;
};
